/* ═══════════════════════════════════════════════════════════════════════════
   RT 2026-10-06: High-value order desk controller
   Pairs with snippets/rt-hv-desk.liquid and assets/rt-high-value.css.

   • Product page: toggles form.rt-hv-on when price x quantity reaches the
     limit (the Liquid already sets it when the unit price alone does).
   • Cart: keeps html.rt-hv-cart in step with the live cart total. rt-cart.js
     patches totals client-side without re-rendering, so Liquid alone would go
     stale; this watches /cart/* requests and re-reads /cart.js.
   • Rebuilds every WhatsApp link at click time with the live quantity / cart.
   • Safety net: swallows checkout / Buy Now / Add to cart activations that
     would push an over-limit order into Razorpay.
   Config comes from window.RTHV, written by layout/theme.liquid.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__rtHvLoaded) return;
  window.__rtHvLoaded = true;

  var C = window.RTHV || {};
  var LIMIT = Number(C.limit) || 10000000;
  var WA = String(C.wa || '919446514691').replace(/\D/g, '');
  var SELLER = 'Beyondwill LLP';
  var BANK_LINE = "I'd like to pay by bank transfer (NEFT/RTGS/IMPS). Please send the GST proforma invoice with " + SELLER + "'s bank details.";
  var VEHICLE_LINE = 'My vehicle (model & year): ';
  var root = document.documentElement;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var cart = null;
  var cartTotal = Number(C.cartTotal) || 0;

  function inr(cents) {
    return '₹' + (Number(cents) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }
  function waHref(text) {
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(text);
  }
  function qtyOf(form) {
    var el = form && form.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(el && el.value, 10) || 1);
  }

  /* ── Messages ───────────────────────────────────────────────────────── */
  function productMessage(desk, intent) {
    var q = qtyOf(desk.closest('form'));
    var price = Number(desk.dataset.price) || 0;
    var lines = ["Hi Rawtorque, I'd like to order:", '', '*' + desk.dataset.title + '*'];
    if (desk.dataset.variant) lines.push('Variant: ' + desk.dataset.variant);
    lines.push('Qty: ' + q);
    lines.push('Price: ' + inr(price) + (q > 1 ? ' each (' + inr(price * q) + ' total)' : ''));
    lines.push(desk.dataset.url, '');
    if (intent === 'bank') lines.push(BANK_LINE, '');
    lines.push(VEHICLE_LINE);
    return lines.join('\n');
  }

  function cartMessage(intent) {
    var lines = ["Hi Rawtorque, I'd like to order my cart:", ''];
    if (cart && cart.items && cart.items.length) {
      cart.items.forEach(function (it) {
        var name = it.product_title + (it.product_has_only_default_variant || !it.variant_title ? '' : ' (' + it.variant_title + ')');
        lines.push('- ' + it.quantity + ' x ' + name + ': ' + inr(it.final_line_price));
      });
      // Cart-level discounts (e.g. the automatic multi-item %) sit between the
      // line prices and the total; show them so the numbers add up.
      var cartDiscount = (cart.items_subtotal_price || 0) - (cart.total_price || 0);
      lines.push('');
      if (cartDiscount > 0) lines.push('Discount: -' + inr(cartDiscount));
      lines.push('Cart total: ' + inr(cart.total_price));
    } else {
      lines.push('Cart total: ' + inr(cartTotal));
    }
    lines.push('');
    if (intent === 'bank') lines.push(BANK_LINE, '');
    lines.push(VEHICLE_LINE);
    return lines.join('\n');
  }

  /* ── Product page: price x quantity ─────────────────────────────────── */
  function syncProductForm(form) {
    if (!form || !form.classList) return;
    var desk = form.querySelector('.rt-hv--product');
    if (!desk) return;
    var price = Number(desk.dataset.price) || 0;
    var on = form.classList.contains('rt-hv-price') || (price > 0 && price * qtyOf(form) >= LIMIT);
    form.classList.toggle('rt-hv-on', on);
  }
  function syncAllProductForms() {
    document.querySelectorAll('form.f8pr-buy-button').forEach(syncProductForm);
  }
  function onQtyEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.name === 'quantity' || t.id === 'product_qty_sticky' || t.closest('.input-amount')) {
      // Let the theme's +/- buttons and the sticky-bar mirror finish first.
      setTimeout(function () {
        var form = t.closest('form.f8pr-buy-button');
        form ? syncProductForm(form) : syncAllProductForms();
      }, 0);
    }
  }
  document.addEventListener('input', onQtyEvent, true);
  document.addEventListener('change', onQtyEvent, true);
  document.addEventListener('click', onQtyEvent, true);

  /* ── Cart total ─────────────────────────────────────────────────────── */
  function applyCart(total) {
    cartTotal = Number(total) || 0;
    root.classList.toggle('rt-hv-cart', cartTotal >= LIMIT);
  }
  var refreshTimer = null;
  function refreshCart() {
    if (!nativeFetch) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      nativeFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { cart = c; applyCart(c.total_price); } })
        .catch(function () {});
    }, 250);
  }
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function urlOf(input) {
    try { return typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) { return ''; }
  }
  if (nativeFetch) {
    window.fetch = function (input) {
      var p = nativeFetch.apply(window, arguments);
      if (CART_MUTATION.test(urlOf(input))) p.then(refreshCart, refreshCart);
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_MUTATION.test(String(url))) this.addEventListener('loadend', refreshCart);
      return xOpen.apply(this, arguments);
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ── Clicks: build WhatsApp links, block over-limit checkout ────────── */
  function visibleDesk(scope) {
    var list = (scope || document).querySelectorAll('.rt-hv');
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) return list[i];
    return null;
  }
  function pointToDesk(scope) {
    var desk = visibleDesk(scope) || visibleDesk(document);
    if (!desk) return;
    desk.scrollIntoView({ behavior: 'smooth', block: 'center' });
    desk.classList.remove('is-flash');
    void desk.offsetWidth;
    desk.classList.add('is-flash');
  }
  function stop(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"][type="submit"], [data-rt-checkout], a[href*="/checkout"], .rt-sum__dynamic';
  var BUY_SEL = 'button[type="submit"], .overlay-dynamic_buy_button, .shopify-payment-button';

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var link = t.closest('a[data-rt-hv-intent]');
    if (link) {
      var desk = link.closest('.rt-hv');
      var intent = link.getAttribute('data-rt-hv-intent');
      link.href = waHref(desk && desk.dataset.rtHv === 'product' ? productMessage(desk, intent) : cartMessage(intent));
      return;
    }

    if (t.closest('.rt-hv-sticky, .rt-hv-bar')) {
      stop(e);
      pointToDesk();
      return;
    }

    if (root.classList.contains('rt-hv-cart') && t.closest(CHECKOUT_SEL)) {
      stop(e);
      pointToDesk(t.closest('#cart'));
      return;
    }

    var form = t.closest('form.f8pr-buy-button.rt-hv-on');
    if (!form) {
      // Sticky bar buttons live outside the form and point at it via form="".
      var ext = t.closest('button[form]');
      var target = ext && document.getElementById(ext.getAttribute('form'));
      if (target && target.matches('form.f8pr-buy-button.rt-hv-on')) form = target;
    }
    if (form && (t.closest(BUY_SEL) || t.closest('button[form]'))) {
      stop(e);
      pointToDesk(form);
    }
  }, true);

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('form.f8pr-buy-button.rt-hv-on')) {
      stop(e);
      pointToDesk(f);
    } else if (root.classList.contains('rt-hv-cart') && f.querySelector('[name="checkout"]')) {
      stop(e);
      pointToDesk(f.closest('#cart'));
    }
  }, true);

  /* ── Boot ───────────────────────────────────────────────────────────── */
  applyCart(cartTotal);
  if (Number(C.cartCount) > 0) refreshCart();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllProductForms);
  } else {
    syncAllProductForms();
  }
})();
